document.addEventListener('DOMContentLoaded', () => {

  /* ===============================
     EXCLUDED COLLECTIONS
  =============================== */
  const EXCLUDED_PATHS = [
    '/collections/accessories'
  ];

  if (EXCLUDED_PATHS.some(path => location.pathname.startsWith(path))) {
    return;
  }

  /* ===============================
     CONFIG
  =============================== */
  const FILTER = 'filter.v.m.custom.size_options';

  const STORAGE_PREFIX = 'savedSize_';
  const OPT_OUT_PREFIX = 'sizeOptedOut_';
  const POPUP_COOKIE_PREFIX = 'sizePopupClosed_';

  /* ===============================
     SIZE DEFINITIONS
  =============================== */
  const SIZE_DEFS = {
    women: {
      detect: [
        'US 0','US 2','US 4','US 6','US 8','US 10','US 12','US 14',
        'US 16','US 17','US 18','US 19','US 20','US 21','SX','S','M','L','XL','2XL','3XL'
      ],
      groups: {
        SX: ['SX', 'US 0', 'US 2'],
        S:  ['S', 'US 4', 'US 6'],
        M:  ['M', 'US 8', 'US 10'],
        L:  ['L', 'US 10', 'US 12'],
        XL: ['XL', 'US 16', 'US 17'],
        '2XL': ['2XL', 'US 18', 'US 19'],
        '3XL': ['3XL', 'US 20', 'US 21']
      }
    },
    men: {
      detect: ['36','38','40','42','44','46','48','50']
    },
    kids: {
      detect: [
        '0-3 Months','0-6 Months','3-6 Months','6-12 Months','1-2 Years',
        '2-3 Years','2-4 Years','3-4 Years','4-5 Years','4-7 Years',
        '5-6 Years','6-7 Years','7-8 Years','8-9 Years','9-10 Years',
        '10-11 Years','11-12 Years','12-13 Years','13-14 Years',
        '14-15 Years','16-17 Years'
      ]
    }
  };

  /* ===============================
     COOKIE HELPERS
  =============================== */
  function setCookie(name, value, days = 365) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(r => r.startsWith(name + '='))?.split('=')[1];
  }

  /* ===============================
     AVAILABLE SIZES
  =============================== */
  const availableSizes = Array.from(
    document.querySelectorAll(`input[name="${FILTER}"]`)
  ).map(i => i.value);

  if (!availableSizes.length) return;

  /* ===============================
     DETECT PAGE TYPE
  =============================== */
  const matchedTypes = [];

  for (const type in SIZE_DEFS) {
    if (availableSizes.some(v => SIZE_DEFS[type].detect.includes(v))) {
      matchedTypes.push(type);
    }
  }

  if (matchedTypes.length !== 1) return;

  const pageType = matchedTypes[0];

  const STORAGE_KEY = `${STORAGE_PREFIX}${pageType}_filter`;
  const OPT_OUT_KEY = `${OPT_OUT_PREFIX}${pageType}`;
  const POPUP_COOKIE = `${POPUP_COOKIE_PREFIX}${pageType}`;






  /* ===============================
     POPUP
  =============================== */
  const popup = document.getElementById('sizeFilterPopup');
  const popupContent = popup?.querySelector('.size-popup-content');
  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  function buildSizeButtons() {
    if (!popup) return;
    const container = popup.querySelector('.size-filter');
    if (!container) return;

    container.innerHTML = '';
    [...new Set(availableSizes)].forEach(size => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = size;
      btn.dataset.size = size;
      btn.className = 'size-btn';
      container.appendChild(btn);
    });
  }

  function openPopup(force = false) {
    if (!popup) return;
    if (!force) {
      if (getCookie(POPUP_COOKIE) === 'true') return;
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      if (sessionStorage.getItem(OPT_OUT_KEY)) return;
    }

    buildSizeButtons();
    popup.style.display = 'flex';
    popup.classList.add('is-open');
    popupContent?.classList.add('size-popup-content-show');
    lockScroll();
  }

  function closePopup() {
    if (!popup) return;
    popup.style.display = 'none';
    popup.classList.remove('is-open');
    popupContent?.classList.remove('size-popup-content-show');
    unlockScroll();
    setCookie(POPUP_COOKIE, 'true');
  }

  document.addEventListener('click', e => {
    if (e.target.closest('.size-popup-close')) closePopup();
    if (e.target.closest('[data-open-size-popup]')) openPopup(true);
  });

  /* ===============================
     SIZE SELECTION
  =============================== */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.size-filter .size-btn');
    if (!btn) return;

    const selected = btn.dataset.size;
    let sizesToApply = [selected];

    if (pageType === 'women') {
      for (const g in SIZE_DEFS.women.groups) {
        if (SIZE_DEFS.women.groups[g].includes(selected)) {
          sizesToApply = SIZE_DEFS.women.groups[g];
          break;
        }
      }
    }

    /* 👉 FILTER ONLY AVAILABLE SIZES */
    sizesToApply = sizesToApply.filter(size => 
      availableSizes.includes(size)
    );

    if (pageType === 'men') {
      localStorage.setItem('savedSize_men', selected);
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(sizesToApply));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sizesToApply));
    sessionStorage.removeItem(OPT_OUT_KEY);
    setCookie(POPUP_COOKIE, 'true');

    const params = new URLSearchParams();
    [...new Set(sizesToApply)].forEach(s => {
  if (availableSizes.includes(s)) {
    params.append(FILTER, s);
  }
});
    window.location.href = `${location.pathname}?${params.toString()}`;
  });

  /* ===============================
     RESTORE FILTER (SAFE + SYNC)
  =============================== */
  if (!sessionStorage.getItem(OPT_OUT_KEY)) {
    const stored =
      JSON.parse(sessionStorage.getItem(STORAGE_KEY)) ||
      JSON.parse(localStorage.getItem(STORAGE_KEY)) ||
      [];

    if (stored.length) {
      const validSizes = stored.filter(v => availableSizes.includes(v));
      const params = new URLSearchParams(location.search);

      if (validSizes.length && !params.getAll(FILTER).length) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(validSizes));
        validSizes.forEach(v => params.append(FILTER, v));
        window.location.replace(`${location.pathname}?${params.toString()}`);
        return;
      }

      if (!validSizes.length) {
        sessionStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(OPT_OUT_KEY);
        setCookie(POPUP_COOKIE, 'false');
        openPopup(true);
      }
    }
  }

  /* ===============================
     FIRST VISIT
  =============================== */
  openPopup();

  /* ===============================
     CLEAR FILTERS
  =============================== */
  document.addEventListener('click', e => {
    const btn = e.target.closest(
      'facet-remove, .active-facets__button-remove, .clear-all'
    );
    if (!btn) return;

    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.setItem(OPT_OUT_KEY, 'true');
    setCookie(POPUP_COOKIE, 'true');

    if (pageType === 'men') {
      localStorage.removeItem('savedSize_men');
    }
  });

});





